var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.839996,
    y: 0.5,
    width: 12.66,
    height: 12.66,
    rx: 6.33,
    stroke: "#848484"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_39188",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 8,
    height: 8
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.70868,
    y: 3.37427,
    width: 6.73736,
    height: 6.73736,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_39188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77057 7.9862C6.77057 7.60722 6.80449 7.33468 6.87233 7.16859C6.94017 7.00249 7.08404 6.82119 7.30394 6.62469C7.49577 6.45625 7.64198 6.31004 7.74257 6.18606C7.84316 6.06207 7.89346 5.92054 7.89346 5.76146C7.89346 5.56964 7.82913 5.41056 7.70046 5.28423C7.5718 5.15791 7.39284 5.09475 7.16358 5.09475C6.92496 5.09475 6.74366 5.16727 6.61968 5.31231C6.49569 5.45735 6.40797 5.60473 6.3565 5.75445L5.63364 5.44565C5.73189 5.14621 5.91202 4.88654 6.17403 4.66664C6.43604 4.44674 6.76589 4.33679 7.16358 4.33679C7.65484 4.33679 8.03265 4.47364 8.297 4.74735C8.56135 5.02106 8.69352 5.34974 8.69352 5.73339C8.69352 5.96733 8.64323 6.16734 8.54263 6.33344C8.44204 6.49953 8.28413 6.68785 8.06891 6.89839C7.83965 7.11829 7.70046 7.28556 7.65134 7.40019C7.60221 7.51481 7.57765 7.71015 7.57765 7.9862H6.77057ZM7.16358 9.67054C7.00918 9.67054 6.87701 9.61556 6.76706 9.50561C6.65711 9.39566 6.60213 9.26349 6.60213 9.10909C6.60213 8.95469 6.65711 8.82252 6.76706 8.71257C6.87701 8.60262 7.00918 8.54764 7.16358 8.54764C7.31798 8.54764 7.45015 8.60262 7.5601 8.71257C7.67005 8.82252 7.72503 8.95469 7.72503 9.10909C7.72503 9.26349 7.67005 9.39566 7.5601 9.50561C7.45015 9.61556 7.31798 9.67054 7.16358 9.67054Z",
    fill: "#848484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b441cd3eac06042a75abf95a1ca17f7a.svg";
export { ForwardRef as ReactComponent };